import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import coreJavaImage from '../../images/cardpageimages/technicalcourse/javaimage.jpg';
import IntroVideos from "../../componants/introvideos";
import CoreJavaModule from "../../componants/allCourseModule/TechnicalCourseModule/CoreJavaModule";

function CoreJava() {
  return (
    <>
      <Header />
      <BannerForAll
        title="CORE JAVA FULL COURSE"
        text="Our Core Java Full Course offers an in-depth introduction to Java programming for beginners. Covering topics such as Java syntax, object-oriented programming concepts, exception handling, multithreading, and basic data structures, this course provides a strong foundation in Java. Perfect for students and professionals alike, it prepares you to tackle advanced Java topics and real-world projects with confidence."
        imageone={coreJavaImage}
        imagetwo={coreJavaImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="CORE JAVA"
      />
      <CoreJavaModule />
      <Footer />
    </>
  );
}

export default CoreJava;
